class CatalogMegaMenu {
  constructor(menu) {
    this.menu = menu;
    this.details = menu.querySelector('details');
    this.categoryLinks = [...menu.querySelectorAll('[data-catalog-category]')];
    this.panels = [...menu.querySelectorAll('[data-catalog-panel]')];

    if (!this.details || this.panels.length === 0) return;

    this.categoryLinks.forEach((link) => {
      link.addEventListener('pointerenter', () => this.activate(link.dataset.catalogCategory));
      link.addEventListener('focus', () => this.activate(link.dataset.catalogCategory));
    });

    this.details.addEventListener('toggle', () => {
      if (this.details.open) this.activateFirstPanel();
    });
  }

  activateFirstPanel() {
    const activeLink = this.categoryLinks.find((link) => link.classList.contains('catalog-mega-menu__category-link--active'));
    const firstPanelLink = this.categoryLinks.find((link) => this.panels.some((panel) => panel.dataset.catalogPanel === link.dataset.catalogCategory));
    this.activate((activeLink || firstPanelLink)?.dataset.catalogCategory);
  }

  activate(category) {
    if (category === undefined) return;
    const panelExists = this.panels.some((panel) => panel.dataset.catalogPanel === category);
    if (!panelExists) return;

    this.categoryLinks.forEach((link) => link.classList.toggle('is-active', link.dataset.catalogCategory === category));
    this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.catalogPanel === category));
  }
}

document.querySelectorAll('.catalog-mega-menu').forEach((menu) => new CatalogMegaMenu(menu));
